export default __webpack_public_path__ + "static/media/byReference.efd31a78.svg";